import PropTypes from 'prop-types';
import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import CardLayout from '../layouts/card';

import styles from './styles.module.scss';
import baseStyles from './tints/base.module.scss';
import cardStyles from './tints/card.module.scss';
import focusStyles from './tints/focus.module.scss';

import UIContext from 'OK/util/context/ui';

export default function ArchiveCardSkeleton(props) {
  const {
    actionIndicatorTint,
    cardTint,
    children,
    className,
    fixedWidth = true,
    layoutOverride,
    listView,
    ...otherProps
  } = props;

  const useDesktopLayout = useSelector((state) => state.app.useDesktopLayout);
  const uiContext = useContext(UIContext);

  /* Render */

  // UI context-specific classes
  const uiContextStyles = useMemo(() => {
    switch (uiContext) {
      case 'card':
        return cardStyles;
      case 'focus':
        return focusStyles;
      default:
        return baseStyles;
    }
  }, [uiContext]);

  // Classes
  const classNames = useMemo(() => {
    const list = [styles.card, uiContextStyles.card];

    if ((useDesktopLayout && layoutOverride !== 'mobile' && !listView) || layoutOverride === 'desktop') {
      list.push(styles.desktop);
    }
    if (fixedWidth) {
      list.push(styles.fixedWidth);
    }
    if (cardTint) {
      list.push(cardTint, uiContextStyles[cardTint]);
    }
    if (className) {
      list.push(className);
    }
    if (listView) {
      list.push(styles.listView);
    }

    return list.join(' ');
  }, [cardTint, className, fixedWidth, layoutOverride, listView, uiContextStyles, useDesktopLayout]);

  return (
    <UIContext.Provider value='card'>
      <CardLayout className={classNames} fixedWidth={false} padded={false} {...otherProps}>
        <div className={styles.imagePlaceholder}></div>
        <div className={styles.bodyPlaceholder}>
          <div className={styles.textContainer}>
            <span className={styles.marginLeft}></span>
            <div className={styles.content}>
              <div className={styles.cardPaddingUpper}>
                <CardLayout className={styles.titleCard} fixedWidth={false}></CardLayout>
              </div>
              <CardLayout className={styles.textCard} fixedWidth={false}></CardLayout>
              <CardLayout className={styles.textCard} fixedWidth={false}></CardLayout>
              {!listView && (
                <>
                  <div className={styles.textCardNone}></div>
                  <div className={styles.textCardNone}></div>
                  <div className={styles.textCardNone}></div>
                </>
              )}
              <div className={styles.cardPaddingLower}>
                <CardLayout className={styles.bottomCard} fixedWidth={false}></CardLayout>
              </div>
            </div>
          </div>
        </div>
      </CardLayout>
    </UIContext.Provider>
  );
}

ArchiveCardSkeleton.propTypes = {
  actionIndicatorTint: PropTypes.oneOf(['alert', 'creation', 'navigation', 'notification']),
  cardTint: PropTypes.oneOf(['alert', 'creation', 'navigation', 'notification']),
  children: PropTypes.node,
  className: PropTypes.string,
  fixedWidth: PropTypes.bool,
  layoutOverride: PropTypes.oneOf(['mobile', 'desktop']),
  listView: PropTypes.bool,
};
